import React from 'react';

export default function getRecoveredTooltipText(sendEmailsEnabled) {
  if (sendEmailsEnabled !== true) {
    return (
      <>
        Number of recovered checkouts over abandonments and total revenue recovered before refunds.{' '}
        <a href="/dashboard/settings/cart-abandonment" className="text-white underline">
          Turn on email reminders
        </a>{' '}
        to recover more abandoned checkouts.
      </>
    );
  }

  return 'Number of recovered checkouts over abandonments and total revenue recovered before refunds.';
}
